import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";
import { RouterModule } from "@angular/router";
import { FeatureEpiserverModule } from "@ha/feature/episerver";
import { HaUiCommonModule } from "@ha/ui/common";
import { HaUtilPipesModule } from "@ha/util/pipes";
import { TranslocoModule } from "@ngneat/transloco";
import { NgxsModule } from "@ngxs/store";

import { NewsListItemComponent } from "./components/news-list/news-list-item.component";
import { NewsListComponent } from "./components/news-list/news-list.component";
import { NewsComponent } from "./components/news/news.component";
import { NewsState } from "./states/news.state";

@NgModule({
    imports: [
        CommonModule,
        HaUiCommonModule,
        NgxsModule.forFeature([NewsState]),
        HaUtilPipesModule,
        RouterModule,
        TranslocoModule,
        FeatureEpiserverModule,
    ],
    exports: [],
    declarations: [NewsComponent, NewsListComponent, NewsListItemComponent],
    providers: [],
})
export class NewsModule {}
